import React from 'react';

import { Button } from '@motorway/mw-highway-code';

import { isNull } from 'Utilities/helpers';

export type ConfirmButtonTypes = {
  isLoading: boolean,
  onClick: () => void,
  title: React.ReactNode,
}

export const ConfirmButton = ({ isLoading, onClick, title }: ConfirmButtonTypes) => {
  if (isNull(title)) {
    return null;
  }

  return (
    <Button
      fullWidth
      disabled={isLoading}
      icon="chevron"
      label={title}
      loading={isLoading}
      onClick={onClick}
    />
  );
};
